define(function () {

    var placeholder = /(\{\d+\})/g;

    function format(args) {
        /* jshint validthis:true */
        args = arguments;
        return this.replace(placeholder, function (match) {
            var i = match.slice(1, -1),
                value = args[i];
            return value === undefined || value === null ? '' : value;
        });
    }

    return function (pattern, args) {
        return format.apply(pattern || '', Array.prototype.slice.call(arguments, 1));
    };
});
